import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';


@Component({
    selector: 'app-session-end',
    templateUrl: './session-end.component.html',
    styleUrl: './session-end.component.scss',
    standalone: false
})
export class SessionEndComponent {
  showConfirmation: boolean = false;

  constructor(private http: HttpClient) { }

  openConfirmation(): void {
    this.showConfirmation = true;
  }

  confirm(): void {
    // Call a function to send data to backend
    this.sendDataToBackend();

    // Reset showConfirmation to hide the pop-up
    this.showConfirmation = false;
  }

  cancel(): void {
    // Perform actions when user cancels
    // Reset showConfirmation to hide the pop-up
    this.showConfirmation = false;
  }

  sendDataToBackend(): void {
    // Assuming you have some data to send, you can construct a payload object
    const dataToSend = {
      // Example data
      sessionId: 123,
      userId: 'user123',
      // Add more data properties as needed
    };

    // Make an HTTP POST request to your backend API
    this.http.post<any>('https://example.com/api/end-session', dataToSend)
      .subscribe(response => {
        console.log('Data sent to backend:', response);
        // Handle response from backend if needed
      }, error => {
        console.error('Error sending data to backend:', error);
        // Handle error if the request fails
      });
  }
}


